const ADMIN_ROLES = new Set(['admin', 'superadmin']);

export function isAdminUser(user) {
  return ADMIN_ROLES.has(user?.role || '');
}
